import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loading',
  templateUrl: 'app/loading/loading.component.html',
  styleUrls: ['app/loading/loading.component.css']
})
export class LoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
